import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input, Col, Button, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Tenable.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { api_url } from "../globalFunction/global_string";
import { faSearch } from '@fortawesome/free-solid-svg-icons';

//掃描模式下拉選單使用方法
import SelectTenableNet from "../BasicComponents/SelectTenableNet";
import SelectTenableUnit from "../BasicComponents/SelectTenableUnit";
import SelectTenableUser from "../BasicComponents/SelectTenableUser";



function CreateTenableExcel() {
    const [formData, setFormData] = useState({
        ip: '',
        hostname: '',
        purpose: '',
        os: ''
    });

    //撈資料出來使用變數
    const [tableData, setTableData] = useState([]);

    //搜尋放大鏡使用
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    // 用於切換模式按鈕狀態
    const [checked, setChecked] = useState(false);

    //編輯的時候挑model出來使用得變數
    const [editData, setEditData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    //domain table data
    const [showTable, setShowTable] = useState(false);
    const [domainData, setdomainData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    //下拉選單使用變數
    const [selectedNet, setSelectedNet] = useState('');
    const [localNetName, setLocalNetName] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [localUnitName, setLocalUnitName] = useState('');
    const [selectedUrl, setSelectedUrl] = useState('');
    const [localUrlName, setLocalUrlName] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [localUserName, setLocalUserName] = useState('');

    //處理文件選擇
    const [file, setFile] = useState(null);


    const loadData = async () => {
        const apiUrl = checked ? `${api_url}/api/JRCC/GetTenableProxyHostip` : `${api_url}/api/JRCC/GetLocalHostIP`;
        const formData = new FormData();
        switch (checked) {
            case true:
                switch (userType) {
                    case "S":
                        formData.append("local_net_id", selectedNet);
                        formData.append("local_unit_id", selectedUnit);
                        break;
                    default:
                        formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
                        formData.append("local_unit_id", selectedUnit);
                        break;
                }

                break;
            case false:
                formData.append("current_user_type", localStorage.getItem('login_user_type'));
                formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
                formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
                formData.append("local_net_name", localStorage.getItem('login_user_net_name'));
                formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'));
                break;
            default:
                break;
        }


        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: formData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Error ${response.status}: ${errorData.row || response.statusText}`);
            }

            const data = await response.json();
            console.log(data);
            if (data.statusCode === 200 && Array.isArray(data.row)) {
                setTableData(data.row);
                setFilteredData(data.row);
            } else {
                throw new Error('無效的回應格式');
            }
        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };


    useEffect(() => {
        loadData();
    }, [checked, selectedUnit]);

    useEffect(() => {
        const results = tableData.filter(row =>
            Object.values(row).some(
                value =>
                    value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredData(results);
    }, [searchTerm, tableData]);
    useEffect(() => {
        if (selectedUser) {
            useridDomaintable();
        }
    }, [selectedUser]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    //新增的按鈕專用
    const handleSubmit = async (e) => {
        e.preventDefault();

        const apiUrl = checked ? `${api_url}/api/JRCC/PostProxyHostIPReference` : `${api_url}/api/JRCC/PostLocaHostIP`;
        const submitData = new FormData();
        if (checked) {
            if (!formData.ip) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請填寫主機IP',
                    icon: 'error'
                });
                return;
            }
            if (!formData.hostname) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請填寫主機名稱',
                    icon: 'error'
                });
                return;
            }

            if (!formData.purpose) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請選擇主機用途',
                    icon: 'error'
                });
                return;
            }

            if (!formData.os) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請選擇主機作業系統',
                    icon: 'error'
                });
                return;
            }
            if (!selectedUser) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請選擇使用者人員',
                    icon: 'error'
                });
                return;
            }
        } else {
            if (!formData.ip) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請填寫主機IP',
                    icon: 'error'
                });
                return;
            }
            if (!formData.hostname) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請填寫主機名稱',
                    icon: 'error'
                });
                return;
            }

            if (!formData.purpose) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請選擇主機用途',
                    icon: 'error'
                });
                return;
            }

            if (!formData.os) {
                Swal.fire({
                    title: '提交失敗',
                    text: '請選擇主機作業系統',
                    icon: 'error'
                });
                return;
            }

        }
        if (checked) {
            switch (userType) {
                case "S":
                    submitData.append("data.host_ip", formData.ip);
                    submitData.append("data.host_name", formData.hostname);
                    submitData.append("data.host_purpose", formData.purpose);
                    submitData.append("data.host_os", formData.os);
                    submitData.append("data.local_net_id", selectedNet);
                    submitData.append("data.local_unit_id", selectedUnit);
                    submitData.append("user_id", selectedUser);
                    break;
                case "M":
                    submitData.append("data.host_ip", formData.ip);
                    submitData.append("data.host_name", formData.hostname);
                    submitData.append("data.host_purpose", formData.purpose);
                    submitData.append("data.host_os", formData.os);
                    submitData.append("data.local_net_id", localStorage.getItem('login_user_net_id'));
                    submitData.append("data.local_unit_id", selectedUnit);
                    submitData.append("user_id", selectedUser);
                    break;
                default:
                    break;
            }

        } else {
            submitData.append("current_user_type", localStorage.getItem('login_user_type'));
            submitData.append("data.host_ip", formData.ip);
            submitData.append("data.host_name", formData.hostname);
            submitData.append("data.host_purpose", formData.purpose);
            submitData.append("data.host_os", formData.os);
            submitData.append("data.local_net_id", localStorage.getItem('login_user_net_id'));
            submitData.append("data.local_unit_id", localStorage.getItem('login_user_unit_id'));
        }


        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: submitData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Error ${response.status}: ${errorData.row || response.statusText}`);
            }

            const data = await response.json();
            if (data.statusCode === 200) {
                Swal.fire({
                    icon: 'success',
                    title: '【新增成功】',
                    text: '恭喜'
                });
                loadData();
                // 清空表單資料
                setFormData({
                    ip: '',
                    hostname: '',
                    purpose: '',
                    os: ''
                });
            } else {
                Swal.fire({
                    title: '提交失敗',
                    text: data.row,
                    icon: 'error'
                });
            }
        } catch (error) {
            console.error('Error submitting data:', error.message);
            Swal.fire({
                title: '提交失敗',
                text: error.message,
                icon: 'error'
            });
        }
    };


    //搜尋使用
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleEdit = (row) => {
        setEditData(row);
        setModalOpen(true);
    };
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData({
            ...editData,
            [name]: value
        });
    };

    //編輯方法
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        console.log(editData)
        const apiUrl = `${api_url}/api/JRCC/PutLocalHostIPReference`;
        const submitData = new FormData();
        submitData.append("data.id", editData.id);
        submitData.append("data.host_name", editData.host_name);
        submitData.append("data.host_purpose", editData.host_purpose);
        submitData.append("data.host_os", editData.host_os);

        try {
            const response = await fetch(apiUrl, {
                method: "PUT",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: submitData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`Error ${response.status}: ${errorData.row || response.statusText}`);
            }

            const data = await response.json();
            if (data.statusCode === 200) {
                Swal.fire({
                    title: '修改成功',
                    icon: 'success'
                });
                setModalOpen(false);
                loadData();
            } else {
                Swal.fire({
                    title: '修改失敗',
                    text: data.row,
                    icon: 'error'
                });
            }
        } catch (error) {
            console.error('Error updating data:', error.message);
            Swal.fire({
                title: '修改失敗',
                text: error.message,
                icon: 'error'
            });
        }
    };

    //刪除方法
    const handleDelete = async (id) => {
        Swal.fire({
            title: '確定要刪除這條記錄嗎？',
            text: "這個操作不能撤銷！",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '是的，刪除它！',
            cancelButtonText: '取消'
        }).then((result) => {
            if (result.isConfirmed) {
                const apiUrl = `${api_url}/api/JRCC/DeleteLocalHostIP`;
                const submitData = new FormData();
                submitData.append("id", id);
                fetch(apiUrl, {
                    method: "Delete",
                    headers: {
                        "Authorization": localStorage.getItem('accessToken')
                    },
                    body: submitData
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.statusCode === 200) {
                            Swal.fire(
                                '刪除成功！',
                                data.row,
                                'success'
                            );
                            loadData();
                        } else {
                            Swal.fire(
                                '刪除失敗',
                                data.row,
                                'error'
                            );
                        }
                    })
                    .catch(error => {
                        console.error('Error deleting data:', error.message);
                        Swal.fire(
                            '刪除失敗',
                            error.message,
                            'error'
                        );
                    });
            }
        });
    };

    const toggleTable = () => {
        setShowTable(!showTable);
        if (!showTable) {
            useridDomaintable();
        }
    };



    const useridDomaintable = async () => {
        const formData = new FormData();

        // 根據 `checked` 決定 API 路徑
        const apiUrl = checked === false
            ? api_url + "/api/Async/GetDomainData"
            : api_url + "/api/Async/GetProxyDomainData";

        // 根據 `checked` 狀態決定表單數據
        if (checked === false) {
            formData.append("user_type", localStorage.getItem("login_user_type"));
            formData.append("loacl_net_id", localStorage.getItem("login_user_net_id"));
            formData.append("user_id", localStorage.getItem("login_user_id"));
        } else {
            if (!selectedUser) {
                console.error("Selected user is required when `checked` is true.");
                return; // 如果 `selectedUser` 未設置，則退出函數
            }
            formData.append("user_id", selectedUser);
        }

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { Authorization: localStorage.getItem("accessToken") },
                body: formData,
            });

            if (!response.ok) {
                // 處理 HTTP 錯誤
                console.error(`HTTP error! status: ${response.status}`);
                return;
            }

            const data = await response.json();

            if (data && Array.isArray(data.row)) {
                // 過濾符合 IP 格式的數據
                const ipFormatRegex = /^(\d{1,3}\.){3}\d{1,3}(\/\d+)?$/;
                const filteredData = data.row.filter((item) => ipFormatRegex.test(item.domain));
                setdomainData(filteredData);
            } else {
                console.error("Received data.row is not an array");
            }
        } catch (error) {
            console.error("Error fetching JSON:", error);
        }
    };



    const nextPage = () => {
        const totalPage = Math.ceil(domainData.length / itemsPerPage);
        if (currentPage < totalPage) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    const currentPageData = domainData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const currentUserId = localStorage.getItem('login_user_id');
    const columns = [
        { name: '區網', selector: row => row.local_net_name },
        { name: '單位', selector: row => row.local_unit_name },
        { name: '主機名稱', selector: row => row.host_name },
        { name: 'IP', selector: row => row.host_ip },
        { name: '主機用途', selector: row => row.host_purpose_name },
        { name: '主機作業系統', selector: row => row.host_os_name },
        { name: '建立人員', selector: row => row.build_id },
        { name: '建立時間', selector: row => row.build_date },
        {
            name: '操作',
            cell: row => (
                (row.build_id === currentUserId || checked) ? (
                    <>
                        <Button size="sm" color="primary" onClick={() => handleEdit(row)}>
                            編輯
                        </Button>
                        <Button size="sm" color="danger" onClick={() => handleDelete(row.id)} className="ml-2">
                            刪除
                        </Button>
                    </>
                ) : null
            )
        }
    ];

    const handleNetSelectChange = (data) => {
        const { value, selectedName } = data;

        // 判斷是否為 "請選擇" 或空值
        if (!value || selectedName.trim() === "請選擇") {
            console.log("清空所有相關狀態");

            setSelectedNet('');
            setLocalNetName('');
            setSelectedUnit('');
            setLocalUnitName('');
            setSelectedUser('');
            setLocalUserName('');
            setSelectedUrl('');
            setLocalUrlName('');

            // 如果是代理模式，額外清空代理相關資料
            if (checked) {
                setSelectedUnit('');
                setLocalUnitName('');
                setSelectedUser('');
                setLocalUserName('');
            }

            return;
        }

        // 如果有值，更新區網狀態
        console.log("更新區網狀態");
        setSelectedNet(value);
        setLocalNetName(selectedName);

        // 清空其他相關狀態
        setSelectedUnit('');
        setLocalUnitName('');
        setSelectedUser('');
        setLocalUserName('');
        setSelectedUrl('');
        setLocalUrlName('');
    };


    const handleUnitSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUnit(value);
        setLocalUnitName(selectedName);
    };
    const handleUrlSelectChange = (data) => {
        console.log(data)
        const { value, selectedName } = data;
    };

    // 切換模式
    const handleProxyChange = () => {
        setChecked(!checked);
        // 重置所有表單資料和選擇項
        setFormData({
            ip: '',
            hostname: '',
            purpose: '',
            os: ''
        });
        setSelectedNet('');
        setLocalNetName('');
        setSelectedUnit('');
        setLocalUnitName('');
        setSelectedUrl('');
        setLocalUrlName('');
        setSelectedUser('');
        setLocalUserName('');
    };

    //以下是代理掃描模式下拉選單使用方法
    const handleProxyUnitSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUnit(value);
        setLocalUnitName(selectedName);
        setSelectedUser('');
        setLocalUserName('');
    };
    const handleUserSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUser(value);
        setLocalUserName(selectedName);
        setSelectedUrl('');
        setLocalUrlName('');
    };

    //下載EXCEL主機範本
    const handleDownload = async () => {
        const fileName = '教育體系網站弱點掃描服務主機匯入範本.xlsx';
        const fileUrl = `${api_url}/${fileName}`;

        const response = await fetch(fileUrl);
        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // 處理文件選擇
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // 匯入EXCEL
    const handleImport = async () => {
        if (!file) {
            Swal.fire({
                title: "請選擇文件",
                icon: "warning",
            });
            return;
        }

        let apiUrl = '';
        const formData = new FormData();

        if (checked === false) {
            apiUrl = `${api_url}/api/JRCC/PostHostIpReference`;
            formData.append("excelFile", file);
            formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
            formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
            formData.append("current_user_type", userType);
        } else {
            apiUrl = `${api_url}/api/JRCC/PostProxyHostIPEXCELReference`;
            switch (userType) {
                case "S":
                    if (!selectedNet || !selectedUnit || !selectedUser) {
                        Swal.fire({
                            title: "匯入失敗",
                            text: "請確保區網、單位及名稱已選擇！",
                            icon: "warning",
                        });
                        return;
                    }
                    formData.append("excelFile", file);
                    formData.append("local_net_id", selectedNet);
                    formData.append("local_unit_id", selectedUnit);
                    formData.append("user_id", selectedUser);
                    formData.append("current_user_type", userType);
                    break;

                case "M":
                    if (!selectedUnit || !selectedUser) {
                        Swal.fire({
                            title: "匯入失敗",
                            text: "請確保單位及名稱已選擇！",
                            icon: "warning",
                        });
                        return;
                    }
                    formData.append("excelFile", file);
                    formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
                    formData.append("local_unit_id", selectedUnit);
                    formData.append("user_id", selectedUser);
                    formData.append("current_user_type", userType);
                    break;

                default:
                    Swal.fire({
                        title: "無效的使用者類型",
                        text: `使用者類型 "${userType}" 無法執行匯入操作！`,
                        icon: "error",
                    });
                    return;
            }

            if (!file) {
                Swal.fire({
                    title: "匯入失敗",
                    text: "請選擇文件！",
                    icon: "warning",
                });
                return;
            }


        }

        try {
            Swal.fire({
                title: "匯入中",
                text: "請稍候，匯入檔案中...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    Authorization: localStorage.getItem("accessToken"),
                },
                body: formData,
            });

            const data = await response.json();

            // 關閉 Loading Spinner
            Swal.close();

            if (data.statusCode !== 200) {
                Swal.fire({
                    title: "匯入失敗",
                    text: data.row || "發生未知錯誤",
                    icon: "error",
                });
                return;
            }

            Swal.fire({
                title: "匯入成功",
                text: "成功匯入",
                icon: "success",
            });
            loadData(); // 重新加載數據
        } catch (error) {
            // 關閉 Loading Spinner
            Swal.close();

            console.error("Error uploading file:", error.message);
            Swal.fire({
                title: "匯入失敗",
                text: error.message || "發生未知錯誤",
                icon: "error",
            });
        }
    };




    //依照user_type的權限來顯示畫面
    const userType = localStorage.getItem('login_user_type');  //權限
    const net_name = localStorage.getItem('login_user_net_name'); //區網名稱
    const unit_name = localStorage.getItem('login_local_unit_name'); //單位名稱

    let FormDataUI = null;
    switch (userType) {
        case "S":
            FormDataUI = checked ?
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7}>
                                <SelectTenableNet
                                    parentName={'superS'}
                                    id={'excel_net_name'}
                                    name={'excel_net_name'}
                                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                                    handleNetSelectChange={handleNetSelectChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superS'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleProxyUnitSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_user_name" sm={3} className="text-right">人員資料</Label>
                            <Col sm={7}>
                                <SelectTenableUser
                                    parentName={'superS'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                    local_unit_name={localUnitName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="ip" sm={3} className="text-right">主機IP</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="ip"
                                    id="ip"
                                    value={formData.ip}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="hostname" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="hostname"
                                    id="hostname"
                                    value={formData.hostname}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="purpose"
                                    id="purpose"
                                    value={formData.purpose}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">個人電腦</option>
                                    <option value="B">伺服器</option>
                                    <option value="C">NAS</option>
                                    <option value="D">IoT</option>
                                    <option value="E">其他</option>
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="os"
                                    id="os"
                                    value={formData.os}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">Windows Series</option>
                                    <option value="B">Windows Server Series</option>
                                    <option value="C">MAC OS Series</option>
                                    <option value="D">BSD Series</option>
                                    <option value="E">Red Hat Series</option>
                                    <option value="F">Debian Series</option>
                                    <option value="G">Other OS</option>
                                </Input>
                            </Col>
                        </FormGroup>
                    </Form>
                ) :
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row>
                            <Label for="ip" sm={3} className="text-right">主機IP</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="ip"
                                    id="ip"
                                    value={formData.ip}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="hostname" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="hostname"
                                    id="hostname"
                                    value={formData.hostname}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="purpose"
                                    id="purpose"
                                    value={formData.purpose}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">個人電腦</option>
                                    <option value="B">伺服器</option>
                                    <option value="C">NAS</option>
                                    <option value="D">IoT</option>
                                    <option value="E">其他</option>
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="os"
                                    id="os"
                                    value={formData.os}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">Windows Series</option>
                                    <option value="B">Windows Server Series</option>
                                    <option value="C">MAC OS Series</option>
                                    <option value="D">BSD Series</option>
                                    <option value="E">Red Hat Series</option>
                                    <option value="F">Debian Series</option>
                                    <option value="G">Other OS</option>
                                </Input>
                            </Col>
                        </FormGroup>

                    </Form>
                );
            break;
        case "M":
            FormDataUI = checked ?
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row className="d-flex align-items-center">
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{net_name}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superM'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_user_name" sm={3} className="text-right">人員資料</Label>
                            <Col sm={7}>
                                <SelectTenableUser
                                    parentName={'superS'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                    local_unit_name={localUnitName}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="ip" sm={3} className="text-right">主機IP</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="ip"
                                    id="ip"
                                    value={formData.ip}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="hostname" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="hostname"
                                    id="hostname"
                                    value={formData.hostname}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="purpose"
                                    id="purpose"
                                    value={formData.purpose}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">個人電腦</option>
                                    <option value="B">伺服器</option>
                                    <option value="C">NAS</option>
                                    <option value="D">IoT</option>
                                    <option value="E">其他</option>
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="os"
                                    id="os"
                                    value={formData.os}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">Windows Series</option>
                                    <option value="B">Windows Server Series</option>
                                    <option value="C">MAC OS Series</option>
                                    <option value="D">BSD Series</option>
                                    <option value="E">Red Hat Series</option>
                                    <option value="F">Debian Series</option>
                                    <option value="G">Other OS</option>
                                </Input>
                            </Col>
                        </FormGroup>
                    </Form>
                ) :
                (
                    <Form onSubmit={handleSubmit}>
                        <FormGroup row className="d-flex align-items-center">
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{net_name}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="ip" sm={3} className="text-right">主機IP</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="ip"
                                    id="ip"
                                    value={formData.ip}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="hostname" sm={3} className="text-right">主機名稱</Label>
                            <Col sm={7}>
                                <Input
                                    type="text"
                                    name="hostname"
                                    id="hostname"
                                    value={formData.hostname}
                                    onChange={handleChange}
                                    required
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="purpose"
                                    id="purpose"
                                    value={formData.purpose}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">個人電腦</option>
                                    <option value="B">伺服器</option>
                                    <option value="C">NAS</option>
                                    <option value="D">IoT</option>
                                    <option value="E">其他</option>
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                            <Col sm={7}>
                                <Input
                                    type="select"
                                    name="os"
                                    id="os"
                                    value={formData.os}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">請選擇</option>
                                    <option value="A">Windows Series</option>
                                    <option value="B">Windows Server Series</option>
                                    <option value="C">MAC OS Series</option>
                                    <option value="D">BSD Series</option>
                                    <option value="E">Red Hat Series</option>
                                    <option value="F">Debian Series</option>
                                    <option value="G">Other OS</option>
                                </Input>
                            </Col>
                        </FormGroup>

                    </Form>
                );
            break;
        case "N":
            FormDataUI = (
                <Form onSubmit={handleSubmit}>
                    <FormGroup row>
                        <Label for="ip" sm={3} className="text-right">主機IP</Label>
                        <Col sm={7}>
                            <Input
                                type="text"
                                name="ip"
                                id="ip"
                                value={formData.ip}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="hostname" sm={3} className="text-right">主機名稱</Label>
                        <Col sm={7}>
                            <Input
                                type="text"
                                name="hostname"
                                id="hostname"
                                value={formData.hostname}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="purpose"
                                id="purpose"
                                value={formData.purpose}
                                onChange={handleChange}
                                required
                            >
                                <option value="">請選擇</option>
                                <option value="A">個人電腦</option>
                                <option value="B">伺服器</option>
                                <option value="C">NAS</option>
                                <option value="D">IoT</option>
                                <option value="E">其他</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="os"
                                id="os"
                                value={formData.os}
                                onChange={handleChange}
                                required
                            >
                                <option value="">請選擇</option>
                                <option value="A">Windows Series</option>
                                <option value="B">Windows Server Series</option>
                                <option value="C">MAC OS Series</option>
                                <option value="D">BSD Series</option>
                                <option value="E">Red Hat Series</option>
                                <option value="F">Debian Series</option>
                                <option value="G">Other OS</option>
                            </Input>
                        </Col>
                    </FormGroup>
                </Form>
            );
            break;

        default:
            break;
    }

    return (
        <div className="mt-5">
            <h1 id="tableLabel" className="mb-3">檢測主機匯入</h1>
            {(userType === 'S' || userType === 'M') && (
                <button
                    className={`mb-3 button-switch ${checked ? "on" : "off"}`}
                    onClick={handleProxyChange}>
                    {checked ? "代理模式" : "掃描模式"}
                </button>
            )}
            <div className="button-container">
                <Button onClick={toggleTable}>主機資料表格</Button>
            </div>
            {showTable && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <table
                        className="customTable table-bordered"
                        style={{
                            margin: '0 auto', // 水平置中
                        }}
                    >
                        <thead>
                            <tr>
                                <th>編號</th>
                                <th>可新增之主機</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData.map((row, index) => (
                                <tr key={index}>
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>{row.domain}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: '5px', // 將按鈕與表格的距離調小
                            gap: '10px', // 控制按鈕和總筆數間距
                        }}
                    >
                        <button
                            className="btn-pagination"
                            disabled={currentPage <= 1}
                            onClick={prevPage}
                        >
                            上一頁
                        </button>
                        <span className="total-items">總共有 {domainData.length} 筆</span>
                        <button
                            className="btn-pagination"
                            disabled={currentPage >= Math.ceil(domainData.length / itemsPerPage)}
                            onClick={nextPage}
                        >
                            下一頁
                        </button>
                    </div>
                </div>
            )}

            <div id="site_manage" className="row col-12 mb-5">
                <div className="row justify-content-center">
                    <div className="row col-sm-12 col-md-10 col-lg-8 rounded-3 d-inline-flex justify-content-center align-content-center mt-4">
                        {FormDataUI}
                    </div>
                    <div className="row col-sm-12  col-md-10 col-lg-8 text-center rounded-3 d-inline-flex justify-content-center align-content-center skin-white ">
                        <Button type="submit" className="btn btn-primary col-md-2 col-lg-1 mx-1 my-2" onClick={handleSubmit}>新增</Button>
                        {
                            <>
                                <Button type="submit_excel" className="btn btn-danger col-md-2 col-lg-1 mx-1 my-2" onClick={handleImport}>匯入</Button>
                                <input class="form-control" type="file" id="formFile" className="col-md-4 col-lg-3 mx-1 my-2 py-1" onChange={handleFileChange} />
                                <a download className="col-md-2 col-lg-1 mx-1 my-2" onClick={handleDownload}>
                                    <FontAwesomeIcon icon={faFileExcel} size="2x" />
                                </a>
                            </>
                        }
                    </div>
                </div>
            </div>


            <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                noDataComponent="There are no records to display"
                persistTableHead
                subHeader
                subHeaderComponent={
                    <div className="row justify-content-end">
                        <div className="col-md-4 input-group">
                            <div className="input-group-prepend bg-info">
                                <span className="input-group-text bg-info" style={{ borderTopLeftRadius: '0.7rem', borderBottomLeftRadius: '0.7rem' }}>
                                    <FontAwesomeIcon icon={faSearch} color="white" />
                                </span>
                            </div>
                            <Input
                                type="text"
                                placeholder="篩選-請輸入文字..."
                                value={searchTerm}
                                onChange={handleSearch}
                                className="form-control"
                            />
                        </div>
                    </div>
                }
            />

            {editData && (
                <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
                    <ModalHeader toggle={() => setModalOpen(!modalOpen)}>編輯主機</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={handleEditSubmit}>
                            <FormGroup row>
                                <Label for="ip" sm={4} className="text-right">主機IP</Label>
                                <Col sm={8}>
                                    <Input
                                        type="text"
                                        name="host_ip"
                                        id="ip"
                                        value={editData.host_ip}
                                        onChange={handleEditChange}
                                        required
                                        readOnly
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="hostname" sm={4} className="text-right">主機名稱</Label>
                                <Col sm={8}>
                                    <Input
                                        type="text"
                                        name="host_name"
                                        id="hostname"
                                        value={editData.host_name}
                                        onChange={handleEditChange}
                                        required
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="purpose" sm={4} className="text-right">主機用途</Label>
                                <Col sm={8}>
                                    <Input
                                        type="select"
                                        name="host_purpose"
                                        id="purpose"
                                        value={editData.host_purpose}
                                        onChange={handleEditChange}
                                        required
                                    >
                                        <option value="">請選擇</option>
                                        <option value="A">個人電腦</option>
                                        <option value="B">伺服器</option>
                                        <option value="C">NAS</option>
                                        <option value="D">IoT</option>
                                        <option value="E">其他</option>
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="os" sm={4} className="text-right">主機作業系統</Label>
                                <Col sm={8}>
                                    <Input
                                        type="select"
                                        name="host_os"
                                        id="os"
                                        value={editData.host_os}
                                        onChange={handleEditChange}
                                        required
                                    >
                                        <option value="">請選擇</option>
                                        <option value="A">Windows Series</option>
                                        <option value="B">Windows Server Series</option>
                                        <option value="C">MAC OS Series</option>
                                        <option value="D">BSD Series</option>
                                        <option value="E">Red Hat Series</option>
                                        <option value="F">Debian Series</option>
                                        <option value="G">Other OS</option>
                                    </Input>
                                </Col>
                            </FormGroup>
                            <ModalFooter>
                                <Button color="secondary" onClick={() => setModalOpen(false)}>取消</Button>
                                <Button type="submit" color="primary" className="ml-2">保存變更</Button>
                            </ModalFooter>
                        </Form>
                    </ModalBody>
                </Modal>
            )}
        </div>
    );
}

export default CreateTenableExcel;
